import React from "react";
import { CreditCardIcon, MapPinIcon, PhoneIcon } from "lucide-react";
import { business } from "../../data/business";
export function MobileActionBar() {
  const item = "flex min-h-[60px] flex-col items-center justify-center gap-1 text-[0.8rem] font-semibold transition-colors duration-150 active:opacity-80";
  return <nav aria-label="Quick actions" className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-gold/30 bg-navy pb-[env(safe-area-inset-bottom)] md:hidden" data-id="element-398" data-mp="170zbywr1ujms">
      <a href={business.phoneHref} className={`${item} bg-gold text-navy`} data-id="element-399" data-mp="y013a15o1nxv">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-400" data-mp="t1hiw56q0k7m" />
        Call Now
      </a>
      <a href={business.payUrl} target="_blank" rel="noopener noreferrer" className={`${item} text-white hover:text-gold-soft`} data-id="element-401" data-mp="o3673owv7zmr">
        <CreditCardIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-402" data-mp="2nez7lviv3n48" />
        Pay Online
      </a>
      <a href={business.directionsUrl} target="_blank" rel="noopener noreferrer" className={`${item} border-l border-white/10 text-white hover:text-gold-soft`} data-id="element-403" data-mp="2ii8rx9ayytjc">
        <MapPinIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-404" data-mp="1gtohltj7u7kw" />
        Directions
      </a>
    </nav>;
}